<div class="permissions-container">
  <div class="avatar-container" [ngStyle]="safariStyle">
    <div class="video-wrapper" [ngClass]="{ hidden: shouldShowAvatarVideo }">
      <app-camera
        #camera
        [onVideoPlaying]="onVideoPlaying"
        [onVideoTimeout]="onVideoTimeout"
        [hasBorder]="true"
      ></app-camera>
    </div>
    @if (shouldShowAvatarPicture) {
      <div>
        <profile-picture [user]="user" [borderWidth]="'5'" [size]="295"></profile-picture>
      </div>
    }
    @if (!disableVideoEffects) {
      <button
        class="fab-video-effects"
        data-testid="video-effects-button"
        mat-mini-fab
        color="#091D50"
        (click)="handleVideoEffectsClick()"
      >
        <mat-icon>auto_awesome</mat-icon>
      </button>
    }
  </div>
  @if (showSmartBadging && smartBadgingHasQuestions && !showWelcomeDeviceSelectionForm) {
    <app-badging-info
      [showRoomActionIcons]="true"
      [isPreviewCard]="true"
      [previewBadgeInfo]="{ userName, companyName, userTitle, aboutMe }"
      [user]="user"
    ></app-badging-info>
  }

  <div
    class="mute-button-container"
    [ngClass]="{ 'footer-buttons': showSmartBadging && !showWelcomeDeviceSelectionForm }"
  >
    <div class="group-item">
      <div class="button-wrapper">
        <button
          id="mute-button-mic"
          class="button-icon"
          data-testid="mute-button-mic"
          mat-mini-fab
          (click)="clickedToggleMic()"
          [ngClass]="{ 'permission-denied': !audioPermissionGranted }"
        >
          @if (!audioPermissionGranted) {
            <mat-icon class="denied-icon" [matTooltip]="'Microphone access permission denied'">info</mat-icon>
          }
          @if (showMicEnabledIcon) {
            <mat-icon>mic</mat-icon>
          } @else {
            <mat-icon> mic_off</mat-icon>
          }
        </button>
        <!-- TODO: Add dropdown here -->
      </div>
    </div>
    <div class="group-item">
      <div class="button-wrapper">
        <button
          id="btn-toggle-video"
          class="button-icon"
          data-testid="btn-toggle-video"
          mat-mini-fab
          (click)="clickedToggleVideo()"
          [disabled]="disableCameraButton"
          [ngClass]="{ 'permission-denied': !videoPermissionGranted }"
        >
          @if (!videoPermissionGranted) {
            <mat-icon class="denied-icon" [matTooltip]="'Camera access permission denied'">info</mat-icon>
          }
          @if (showVideoEnabledIcon) {
            <mat-icon>videocam</mat-icon>
          } @else {
            <mat-icon>videocam_off</mat-icon>
          }
        </button>
        <!-- TODO: Add dropdown here -->
      </div>
    </div>
  </div>
</div>
